import React, { useCallback, useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PortfolioService from '../../services/portfolio.service'
import { getAccountListSelector } from '../../store/selectors/app.selector'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import Loading from 'custom/assets/loaders/Loading'
import NumberFormat from 'react-number-format'
import CustomPagination from '../../components/pagination'
import { useTranslation } from 'react-i18next'
import { LOANS_KEYS } from '../../utils/translation-constants'
import moment from 'moment'

export default function LoansView() {
  const history = useHistory()
  const accounts = useSelector(getAccountListSelector) || []
  const [loanList, setLoanList] = useState([])
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [loanDetails, setLoanDetails] = useState({})
  const [loanStatementDetails, setLoanStatementDetails] = useState([])
  const [noRecords, setNoRecords] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const [tabIndex, setTabIndex] = useState(1)
  const [expandedStatement, setExpandedStatement] = useState(null)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(5)
  const { t } = useTranslation()

  useEffect(() => {
    getAccountDetails()
  }, [])

  const getAccountDetails = useCallback(async () => {
    try {
      const response = await PortfolioService.getAccountDetails({
        accountType: 'L',
      })
      if (response.status === 200) {
        setNoRecords(response.data['accountSummaryDetails'].length > 0 ? false : true)
        setLoanList(response.data['accountSummaryDetails'])
        setStage(1)
      }
    } catch (err) {}
  }, [])

  const getLoanDetails = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        const response = await PortfolioService.getLoanDetails(selected)
        if (response.status === 200) {
          setLoading(false)
          setLoanDetails(response.data)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [loanList],
  )

  const getLoanStatement = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        const response = await PortfolioService.getLoanStatement(selected)
        if (response.status === 200) {
          setLoading(false)
          setLoanStatementDetails(response.data['loanAccList'])
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [loanList],
  )

  // const handleChange = useCallback((value) => {
  //   setExpandedStatement(null)
  //   setMinValue((value - 1) * 5)
  //   setMaxValue(value * 5)
  // }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderList()
      default:
        return renderList()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderView() {
    return (
      <>
        {!loading && (
          <Row>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.USER_REF_NO)}</label>
              <span>{loanDetails?.userRefNo}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.ACC_DESC)}</label>
              <span>{loanDetails?.accDesc || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.ACCOUNT_NO)}</label>
              <span>{loanDetails?.accountNo || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.AMOUNT_PAID)}</label>
              <span>
                <NumberFormat
                  value={loanDetails?.amountPaid}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.BRN_CODE)}</label>
              <span>{loanDetails?.brnCode || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.CURRENCY)}</label>
              <span>{loanDetails?.currency || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.CUSTOMER_ID)}</label>
              <span>{loanDetails?.customerId || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.INTEREST_RATE)}</label>
              <span>{loanDetails?.interestRate || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.NEXT_PAYMENT_DATE)}</label>
              <span>
                {loanDetails?.nextPaymentDate !== null
                  ? moment(loanDetails?.nextPaymentDate).format('YYYY-MM-DD')
                  : '-'}
              </span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.OUT_STANDING_BALANCE)}</label>
              <span>
                <NumberFormat
                  value={loanDetails?.outstandingBalance}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.PROD_CATEGORY)}</label>
              <span>{loanDetails?.prodCategory || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.MATURITY_DATE)}</label>
              <span>
                {loanDetails?.maturityDate !== null
                  ? moment(loanDetails?.maturityDate).format('YYYY-MM-DD')
                  : '-'}
              </span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.PRINCIPLE_AMOUNT)}</label>
              <span>
                {' '}
                <NumberFormat
                  value={loanDetails?.principleAmount}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.REPAYMENT_INSTALLMENT)}</label>
              <span>{loanDetails?.rePaymentInstallment || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.REPAYMENT_STATUS)}</label>
              <span>{loanDetails?.repaymentStatus || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.STATUS)}</label>
              <span>{loanDetails?.status || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.REMAINING_NO_REPAYMENT)}</label>
              <span>{loanDetails?.remainingNoRepayment || '-'}</span>
            </Col>
            <Col xs={4} sm={4} md={4}>
              <label>{t(LOANS_KEYS.VALUE_DATE)}</label>
              <span>
                {loanDetails['valueDate'] !== null
                  ? moment(loanDetails?.valueDate).format('YYYY-MM-DD')
                  : '-'}
              </span>
            </Col>
          </Row>
        )}
      </>
    )
  }

  function renderStatement() {
    return (
      <>
        {loanStatementDetails.length === 0 && (
          <div className='no-data-found'>{t(LOANS_KEYS.NO_STATEMENT)} </div>
        )}
        {loanStatementDetails.slice(minValue, maxValue).map((option, index) => (
          <div key={index} className='approval-card' style={{ backgroundColor: '#fff' }}>
            <div
              className='approval-card-header'
              onClick={async () => {
                if (expandedStatement == index) {
                  setExpandedStatement(null)
                } else {
                  setExpandedStatement(index)
                }
              }}>
              <span>
                {t(LOANS_KEYS.REF_NUMBER)} : {option.refNo}
              </span>
              <NumberFormat
                value={option?.amount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </div>

            {expandedStatement === index && (
              <div className='approval-card-body'>
                <Row>
                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.ACCOUNT_NO)}</label>
                    <span>{option.accNo}</span>
                  </Col>

                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.AMOUNT)}</label>
                    <span>
                      <NumberFormat
                        value={option.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                    </span>
                  </Col>

                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.REF_NO)}</label>
                    <span>{option.refNo}</span>
                  </Col>
                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.SETTELED_ACCOUNT_NO)}</label>
                    <span>{option.settledAccountNo}</span>
                  </Col>
                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.SL_NUMBER)}</label>
                    <span>{option.slNumber}</span>
                  </Col>
                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.TRANSACTION_DATE)}</label>
                    <span>
                      {' '}
                      {option?.transactionDate !== null
                        ? moment(option?.transactionDate).format('YYYY-MM-DD')
                        : '-'}
                    </span>
                  </Col>

                  <Col xs={4} sm={4} md={4}>
                    <label>{t(LOANS_KEYS.NARRATION)}</label>
                    <span>{option.narration}</span>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        ))}
        <div>
          {loanStatementDetails.length > 5 && (
            <CustomPagination
              defaultPageSize={5}
              setMaxValue={(value) => {
                setExpandedStatement(null)
                setMaxValue(value)
              }}
              setMinValue={(value) => setMinValue(value)}
              totalLength={loanStatementDetails.length}
              defaultCurrent={1}
            />
          )}
        </div>
      </>
    )
  }

  function renderList() {
    return (
      <>
        {noRecords && <div className='no-data-found'>{t(LOANS_KEYS.NO_LOAN_ACCOUNTS)} </div>}

        {loanList.map((option, index) => (
          <div key={index} className='approval-card'>
            <div
              className='approval-card-header'
              onClick={async () => {
                if (expanded == index) {
                  setExpanded(null)
                  setExpandedStatement(null)
                } else {
                  setTabIndex(1)
                  setExpanded(index)
                  setExpandedStatement(null)
                  setMaxValue(5)
                  setMinValue(0)
                  await getLoanDetails(option)
                  await getLoanStatement(option)
                }
              }}>
              <span>{t(LOANS_KEYS.LOAN_ACCOUNT_NUMBER)}</span>
              <span>{option?.accountNo}</span>
            </div>

            {expanded === index && (
              <div className='approval-card-body'>
                <div className='row tab-navbar'>
                  <div className={tabIndex === 1 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(1)
                        setExpandedStatement(null)
                      }}>
                      {t(LOANS_KEYS.VIEW_DETAILS)}
                    </span>
                  </div>
                  <div className={tabIndex === 2 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(2)
                      }}>
                      {t(LOANS_KEYS.STATEMENT_DETAILS)}
                    </span>
                  </div>
                </div>
                {loading && renderLoading()}
                {tabIndex === 1 && !loading && renderView()}
                {tabIndex === 2 && !loading && renderStatement()}
              </div>
            )}
          </div>
        ))}
      </>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='LOANS_VIEW' keyPath={'LOAN'} showEmptySpace={true}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div className='heading-style'>{t(LOANS_KEYS.HEADER)}</div>
        </div>
      </div>

      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
